import {
    ADD_INVENTORY_CATEGORIES,
    EDIT_INVENTORY_CATEGORIES,
    FETCH_INVENTORY_CATEGORIES,
    DELETE_INVENTORY_CATEGORIES
} from "../actionTypes";

const fetchInventoryCategories = (state = [], action) => {
    switch (action.type) {
        
        case FETCH_INVENTORY_CATEGORIES:
            state = [];
            return [...state, ...action.categories];
        
        case ADD_INVENTORY_CATEGORIES:
            return [action.category, ...state];
        
        case EDIT_INVENTORY_CATEGORIES:
            return state.map(category => {
                if (category.id === action.category.id) {
                    return {
                        category,
                        ...action.category
                    };
                }
                return category;
            });
        
        case DELETE_INVENTORY_CATEGORIES:
            return state.filter(({ id }) => id !== action.id);
        
        default:
            return state;
    }
};

export default fetchInventoryCategories;